let resumeData = {
    "imagebaseurl": "http://localhost:3000",
    "name": "Daniel McCarthy",
    "role": "technophile, customer advocate and problem solver",
    "roleDescription": "I have been in technology, mostly higher ed tech, my entire adult life, and have actively participated in portions of an SDLC. I've held customer facing roles and find the greatest satisfaction in delivering a quality and useful product to users of all types."
}

export default resumeData;